import styled from 'styled-components';
import { navBarHeight } from '../../utils/styles-constants';

export const GalleryContainer = styled('div')`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
`;

export const GalleryChildrenContainer = styled('div')``;

interface PageProps {
	withPadding?: boolean;
}

export const Page = styled('div')`
	background: ${props => props.theme.primary.backgroundColor};
	padding: ${(props: PageProps) => props.withPadding ? '10px' : 0};
	position: absolute;
	top: ${navBarHeight};
	left: 0;
	right: 0;
	bottom: 0;
	overflow: auto;
	-webkit-overflow-scrolling: touch;
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Gallery/styles.ts